import { useSelector } from 'react-redux'
import { formatBallot } from '../fmt.js'
import { selectBallot, selectIsStateValid } from '../stores/store.js'

export function MessageOutput({ ballot, isStateValid }) {
  const content = formatBallot(ballot)
  const classList = [
    isStateValid ? "border-green-400" : "border-red-400"
  ]
  return <div>
    <textarea className={"p-2 border rounded bg-white text-gray-800 resize-none " + classList.join(" ")} disabled style={{ minHeight: "200px" }} value={content}></textarea>
  </div>
}

export function MessageOutputStateful() {
  const ballot = useSelector(selectBallot)
  const isStateValid = useSelector(selectIsStateValid)
  return <MessageOutput ballot={ballot} isStateValid={isStateValid} />
}
